<small class="debug">{{me}}</small>
@if (showHeader) {
  <app-header [showMenu]="true">
  </app-header>
}

<div style="position: relative;">
  @if (showBack) {
    <a color="warn" class="back-button mini-button" mat-icon-button routerLink="/login">
      <fa-icon [icon]="faRightFromBracket" matTooltip="{{'account.back' | transloco}}"></fa-icon>
    </a>
  }
    <!-- Alon
  @if (showToggle) {
    <button class="hide-lt-sm toggle-button mini-button" matTooltip="{{'navigation.toggleVideoList' | transloco}}" mat-icon-button (click)="toggleVideoPane()">
      @if (toggleIcon) {
        <mat-icon>keyboard_double_arrow_left</mat-icon>
      }
      @if (!toggleIcon) {
        <mat-icon>keyboard_double_arrow_right</mat-icon>
      }
    </button>
  }
  -->
  <mat-tab-group #tabGroup tabGroupDrag animationDuration="0ms" (selectedTabChange)="onSelectedTabChange($event)" mat-stretch-tabs="false" mat-align-tabs="start" [ngClass]="{'show-back': showBack}">
    <mat-tab label="videos" >
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">video_library</mat-icon>
        {{'general.videos' | transloco}}
      </ng-template>
      @if (showTutorials) {
        <app-tutorials [setAutoPlayVideoId]="autoPlayVideoId" #tutorials></app-tutorials>
      }
      @if (!showTutorials) {
        <div fxLayout="row" fxLayoutAlign="center center" class="whiteLabelVideo">
          <button (click)="onWhiteLabelVideo()" mat-raised-button>
            <mat-icon>play_circle_outline</mat-icon>
            {{videoUrlWhiteLabel}}
          </button>
        </div>
      }
    </mat-tab>
    <mat-tab label="chat" >
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">3p</mat-icon>
        {{'general.liveChat' | transloco}}
      </ng-template>
      <app-chat-customer #chatApp [setResellerId]="resellerId"></app-chat-customer>
    </mat-tab>
    <mat-tab label="contact" >
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">outgoing_mail</mat-icon>
        {{'general.contact' | transloco}}
      </ng-template>
      <!--        <h1>{{'general.customerFeedback' | transloco}}</h1>-->
      <!--            <h1>contact and subscription</h1>-->
      <app-contact></app-contact>
    </mat-tab>
  </mat-tab-group>
</div>
